import { GlobalStore } from "store/global/GlobalStore";
import { estimateWrapping, isWrapToken } from "utils/wrapUtils";
import { Hash, WalletClient } from "viem";
import { usePublicClient, useWalletClient } from "wagmi";
import { useTokenListByChain } from "hooks/useTokenListByChain";
import { isAddressEqual } from "../../utils/tokenUtils";

export const useGetMaxAmountToWrap = () => {
  const network = GlobalStore.useState(s => s.network);
  const balances = GlobalStore.useState(s => s.balances);
  const { data: walletClient } = useWalletClient();
  const publicClient = usePublicClient();
  const tokenList = useTokenListByChain();

  return async (tokenAddress: Hash) => {
    const maxBalanceForSymbol = balances.find(balance =>
      isAddressEqual(balance.tokenAddress, tokenAddress)
    )?.balance;
    if (isWrapToken(tokenAddress, network)) {
      return maxBalanceForSymbol;
    }
    if (maxBalanceForSymbol == null || tokenList == null) {
      return null;
    }
    const gasCost = await estimateWrapping(
      "deposit",
      tokenAddress,
      maxBalanceForSymbol,
      walletClient as WalletClient,
      publicClient,
      tokenAddress,
      tokenList
    );

    return maxBalanceForSymbol.sub(gasCost);
  };
};
